import styles from '../Fetch.module.css';

export function FetchLogo() {
  return (
    <span
      className={styles.fetchLogoImg}
      role="img"
      aria-label="Fetch Pet Insurance"
    />
  );
}
